<div class="flex flex-col update-configuration-dialog"> 
  <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>
  <div class="flex flex-row justify-between items-center header mb-24 w-100-percent">
    <div class="mat-body-1 fw-700 title m-0">
      <span class="mr-8 mat-headline-6 fw-700 fs-16">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.SELECT_RELEASE_PACKAGE' | transloco }}</span>
      <span>({{ filteredConfigurations.length === configurations.length ? configurations.length :
        ('COMMON.NUMBER_OF_TOTAL' | transloco : {num: filteredConfigurations.length , total:configurations.length }) }})</span>
    </div>

    <app-search-filter placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
  </div>
  <div class="tbl tbl-configuration w-100-percent height-view-release">
    <div class="tbl-header-row primary mb-8">
      <div class="tbl-cell col-expand"></div>
      <div class="tbl-cell col-select"></div>
      <div class="tbl-cell col-release-package-name">
        {{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.RELEASE_PACKAGE_NAME' | transloco }}</div>
      <div class="tbl-cell col-version">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.VERSION' | transloco }}</div>
      <div class="tbl-cell col-date-generated">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.DATE_GENERATED' | transloco }}
      </div>
    </div>
    <div class="tbl-body">
      <div *ngFor="let configuration of pageConfigurations" class="tbl-border mb-8">
        <div class="tbl-body-row tbl-high-row"
          [ngClass]="[selection === configuration ? 'selected' : (expandedRows[configuration.id] ? 'expanded' : '')]">
          <div class="flex items-center tbl-cell col-expand user-select-none"
            (click)="expandRow(configuration)">
            <mat-icon class="cursor-pointer"
              [svgIcon]="expandedRows[configuration.id] ? 'expand_more' : 'chevron_right'"></mat-icon>
          </div>
          <div class="flex items-center tbl-cell col-select user-select-none"
            (click)="select(configuration)">
            <mat-icon *ngIf="selection !== configuration" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
            <mat-icon *ngIf="selection === configuration" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
            </mat-icon>
          </div>
          <div class="tbl-cell col-release-package-name">
            {{ configuration.manifest.name }}
            <div *ngIf="configuration?.manifest?.code" class="code-package ml-16"><mat-icon svgIcon="integration_instructions" [matTooltip]="'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.CODE_PACKAGE_AVAILABLE' | transloco | titlecase" 
              matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16" class="icon-md-1"></mat-icon></div>
            <button *ngIf="configuration?.hotfix === true" class="flex flex-row jutsify-center items-center hotfix mt-4 ml-16 h-16 w-55 fw-700 fs-10 cursor-default">{{'BUTTONS.HOTFIX' | transloco}}</button>
          </div>
          <div class="tbl-cell col-version">
            {{ configuration.manifest.version }}
          </div>
          <div class="tbl-cell col-date-generated">
            {{ configuration.manifest.dataGenerated | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET }}
          </div>
        </div>

        <div *ngIf="expandedRows[configuration.id]" class="configuration-details">
          <div class="section-label">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.CONFIGURATION_PACKAGE' | transloco }}
          </div>
          <div class="tbl tbl-border tbl-configuration-package">
            <div class="tbl-header-row secondary">
              <div class="tbl-cell col-filename">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
              </div>
              <div class="tbl-cell col-description">
                {{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}</div>
            </div>
            <div class="tbl-body">
              <div *ngFor="let configurationPackage of configuration.manifest.config.packages" class="tbl-body-row">
                <div class="tbl-cell col-filename">{{ configurationPackage.name }}</div>
                <div class="tbl-cell col-description">{{ configurationPackage.description }}</div>
              </div>
            </div>
          </div>
           <div class="section-label">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.ENV_PACKAGE' | transloco }}
          </div>
          <div class="tbl tbl-border tbl-configuration-package">
            <div class="tbl-header-row secondary">
              <div class="tbl-cell col-filename">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
              </div>
              <div class="tbl-cell col-description">
                {{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}</div>
            </div>
            <div class="tbl-body">
              <div *ngFor="let configurationPackage of configuration?.manifest?.envProp?.packages" class="tbl-body-row">
                <div class="tbl-cell col-filename">{{ configurationPackage.name }}</div>
                <div class="tbl-cell col-description">{{ configurationPackage.description }}</div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="configuration?.manifest?.code">
            <div class="section-label">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.CODE_PACKAGE' | transloco }}</div>
            <div class="tbl tbl-border tbl-test-package">
              <div class="tbl-header-row secondary">
                <div class="tbl-cell col-filename">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
                </div>
                <div class="tbl-cell col-start-time">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}
                </div>
              </div>
              <div class="tbl-body">
                <div *ngFor="let codePackage of configuration.manifest.code.packages" class="tbl-body-row">
                  <div class="tbl-cell col-filename">{{ codePackage.name }}</div>
                  <div class="tbl-cell col-description">{{ codePackage.description }}</div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="section-label">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.TEST_PACKAGE' | transloco }}</div>
          <div class="tbl tbl-border tbl-test-package">
            <div class="tbl-header-row secondary">
              <div class="tbl-cell col-filename">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
              </div>
              <div class="tbl-cell col-start-time">{{ 'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}
              </div>
            </div>
            <div class="tbl-body">
              <div *ngFor="let testPackage of configuration.manifest.test.packages" class="tbl-body-row">
                <div class="tbl-cell col-filename">{{ testPackage.name }}</div>
                <div class="tbl-cell col-description">{{ testPackage.description }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <span class="flex-auto"></span>

  <app-paginator></app-paginator>
  <mat-divider class="mt-32 mb-32 neutral-2"></mat-divider>

  <ng-container>
    <div class="flex flex-row gap-x-4" dir="rtl">
      <button class="accent" type="button" [ngClass]="{'disabled': !selection}"
        (click)="applyConfiguration()">{{'BUTTONS.SUBMIT' | transloco}}</button>
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}
      </button>
    </div>
  </ng-container>
</div>
